const settings = {
	dots: false,
	arrows: false,
	infinite: true,
	autoplay: true,
	autoplaySpeed: 8000,
	speed: 2000,
	pauseOnHover: false
};

export default settings;



// WEBPACK FOOTER //
// ./src/components/jumbotron/settings.js